import prfKendoWindow from './prf-kendo-window';
import prfConstruction from './prf-construction/prf-construction-info';
import prfMaintenance from './prf-service-agreement/prf-service-agreement';
import prfBranchGrid from './prf-grid';

export default function (nameAction, namePage) {
    /*General*/
    prfKendoWindow();
    if (nameAction === 'branchgrid') prfBranchGrid();

    /*PRF Construction*/
    if (nameAction === 'construction') prfConstruction();

    /*PRF Service Agreement*/
    if (nameAction === 'maintenance') prfMaintenance();
}